import React from 'react'
import PropTypes from 'prop-types'
import IconDone from 'client/icons/Done'
import { CheckboxBase, Text } from './styles'

const Checkbox = ({
  className,
  error,
  isFocused = false,
  label,
  link,
  name,
  onChange,
  onFocus,
  required = false,
  selected,
  type = 'checkbox',
  dataTestId,
}) => {
  return (
    <CheckboxBase htmlFor={name} isChecked={selected} isFocused={isFocused} error={error}>
      <input
        data-testid={dataTestId}
        role="checkbox"
        aria-checked={selected}
        checked={selected}
        id={name}
        name={name}
        onChange={() => onChange({ name })}
        onFocus={onFocus}
        type={type}
      />
      <IconDone />

      <Text className={className} asterisk={required}>
        {link || label}
      </Text>
    </CheckboxBase>
  )
}

Checkbox.propTypes = {
  className: PropTypes.string,
  error: PropTypes.bool,
  isFocused: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  link: PropTypes.instanceOf(Object),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  required: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  type: PropTypes.string,
  dataTestId: PropTypes.string,
}

export default Checkbox
